import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
const painPoints = ['Llegás a la clase sin saber exactamente qué elemento vas a trabajar hoy con cada grupo', 'Tus alumnos no progresan porque no tenés una secuencia clara de aparato en aparato', 'El 40% de tus alumnos abandona antes de los 3 meses porque no ven avance y no sabés cómo prevenirlo', 'Siempre los mismos ejercicios de siempre porque no tenés más material técnico listo para usar', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible y documentado', 'Correcciones técnicas improvisadas en el piso, sin un protocolo claro de spotting que te respalde', 'Alumnos de distintas edades y niveles juntos y la clase se convierte en un caos difícil de manejar', 'Fin de mes y los alumnos se van sin avisar porque no ven progresión real en sus clases de artística'];
export function PainPointsSection() {
  return <Section data-id="element-203">
      <div className="max-w-4xl mx-auto" data-id="element-204">
        <div className="text-center mb-5 md:mb-12" data-id="element-205">
          <h2 className="text-xl md:text-4xl font-bold text-white leading-tight" data-id="element-206">
            Si sos profesor/a de gimnasia artística en Argentina,{' '}
            <br className="hidden md:block" data-id="element-207" />
            <span className="text-magenta-500" data-id="element-208">
              esto te va a sonar familiar:
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-2.5 md:gap-6 mb-8 md:mb-16" data-id="element-209">
          {painPoints.map((point, index) => <div key={index} className="flex space-x-3 bg-navy-800/50 p-3 md:p-6 rounded-lg md:rounded-xl border border-navy-700 hover:border-navy-600 transition-colors" data-id="element-210">
              <div className="flex-shrink-0" data-id="element-211">
                <div className="w-7 h-7 md:w-10 md:h-10 rounded-full bg-navy-900 border border-navy-700 flex items-center justify-center text-gray-400 font-bold font-mono text-xs md:text-base" data-id="element-212">
                  0{index + 1}
                </div>
              </div>
              <p className="text-gray-300 leading-snug text-sm md:text-base md:leading-relaxed" data-id="element-213">
                {point}
              </p>
            </div>)}
        </div>

        <div className="bg-gradient-to-r from-magenta-600/20 to-gold-500/20 border border-magenta-500/30 rounded-xl md:rounded-2xl p-5 md:p-12 text-center relative overflow-hidden" data-id="element-214">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-magenta-500 to-gold-500" data-id="element-215"></div>
          <AlertCircle className="w-8 h-8 md:w-12 md:h-12 text-magenta-500 mx-auto mb-3 md:mb-6" data-id="element-216" />
          <h3 className="text-xl md:text-4xl font-black text-white" data-id="element-217">
            ¿Cuántas clases más vas a improvisar{' '}
            <br className="hidden md:block" data-id="element-218" />
            antes de tener un sistema real?
          </h3>
        </div>
      </div>
    </Section>;
}